var _path, _g, _path2, _g2, _path3, _path4, _path5, _g3, _path6, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8734 5.8913C24.5199 5.8913 24.2421 6.18291 24.1495 6.52403C23.8716 7.54867 22.935 8.3023 21.8224 8.3023C20.7098 8.3023 19.7732 7.54867 19.4953 6.52403C19.4028 6.18291 19.1249 5.8913 18.7714 5.8913H9.32305C7.55572 5.8913 6.12305 7.324 6.12305 9.0913V16.9894C6.12305 18.7567 7.55572 20.1894 9.32305 20.1894H18.7714C19.1249 20.1894 19.4028 19.8978 19.4953 19.5567C19.7732 18.5321 20.7098 17.7784 21.8224 17.7784C22.935 17.7784 23.8716 18.5321 24.1495 19.5567C24.2421 19.8978 24.5199 20.1894 24.8734 20.1894H26.2355C28.0028 20.1894 29.4355 18.7567 29.4355 16.9894V9.0913C29.4355 7.324 28.0028 5.8913 26.2355 5.8913H24.8734Z",
    fill: "url(#paint0_radial_2149_30967)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_i_2149_30967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8734 5.8913C24.5199 5.8913 24.2421 6.18291 24.1495 6.52403C23.8716 7.54867 22.935 8.3023 21.8224 8.3023C20.7098 8.3023 19.7732 7.54867 19.4953 6.52403C19.4028 6.18291 19.1249 5.8913 18.7714 5.8913H9.32305C7.55572 5.8913 6.12305 7.324 6.12305 9.0913V16.9894C6.12305 18.7567 7.55572 20.1894 9.32305 20.1894H18.7714C19.1249 20.1894 19.4028 19.8978 19.4953 19.5567C19.7732 18.5321 20.7098 17.7784 21.8224 17.7784C22.935 17.7784 23.8716 18.5321 24.1495 19.5567C24.2421 19.8978 24.5199 20.1894 24.8734 20.1894H26.2355C28.0028 20.1894 29.4355 18.7567 29.4355 16.9894V9.0913C29.4355 7.324 28.0028 5.8913 26.2355 5.8913H24.8734Z",
    fill: "url(#paint1_radial_2149_30967)",
    fillOpacity: 0.01
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8734 5.8913C24.5199 5.8913 24.2421 6.18291 24.1495 6.52403C23.8716 7.54867 22.935 8.3023 21.8224 8.3023C20.7098 8.3023 19.7732 7.54867 19.4953 6.52403C19.4028 6.18291 19.1249 5.8913 18.7714 5.8913H9.32305C7.55572 5.8913 6.12305 7.324 6.12305 9.0913V16.9894C6.12305 18.7567 7.55572 20.1894 9.32305 20.1894H18.7714C19.1249 20.1894 19.4028 19.8978 19.4953 19.5567C19.7732 18.5321 20.7098 17.7784 21.8224 17.7784C22.935 17.7784 23.8716 18.5321 24.1495 19.5567C24.2421 19.8978 24.5199 20.1894 24.8734 20.1894H26.2355C28.0028 20.1894 29.4355 18.7567 29.4355 16.9894V9.0913C29.4355 7.324 28.0028 5.8913 26.2355 5.8913H24.8734Z",
    fill: "url(#paint2_radial_2149_30967)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_di_2149_30967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8954 12.1873C22.4266 12.1873 22.8572 11.7566 22.8572 11.2255C22.8572 10.6943 22.4266 10.2637 21.8954 10.2637C21.3642 10.2637 20.9336 10.6943 20.9336 11.2255C20.9336 11.7566 21.3642 12.1873 21.8954 12.1873ZM21.8954 15.8169C22.4266 15.8169 22.8572 15.3863 22.8572 14.8551C22.8572 14.324 22.4266 13.8934 21.8954 13.8934C21.3642 13.8934 20.9336 14.324 20.9336 14.8551C20.9336 15.3863 21.3642 15.8169 21.8954 15.8169Z",
    fill: "url(#paint3_linear_2149_30967)",
    fillOpacity: 0.7
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3227 11.8103C20.9693 11.8103 20.6914 12.1019 20.5989 12.443C20.3209 13.4677 19.3844 14.2213 18.2718 14.2213C17.1591 14.2213 16.2226 13.4677 15.9446 12.443C15.8521 12.1019 15.5742 11.8103 15.2207 11.8103H5.77227C4.00497 11.8103 2.57227 13.243 2.57227 15.0103V22.9084C2.57227 24.6757 4.00497 26.1084 5.77227 26.1084L15.2208 26.1084C15.5743 26.1084 15.8521 25.8168 15.9446 25.4757C16.2226 24.4511 17.1592 23.6974 18.2718 23.6974C19.3844 23.6974 20.321 24.4511 20.5989 25.4757C20.6914 25.8168 20.9693 26.1084 21.3228 26.1084H22.6847C24.452 26.1084 25.8847 24.6757 25.8847 22.9084V15.0103C25.8847 13.243 24.452 11.8103 22.6847 11.8103H21.3227Z",
    fill: "#30B4F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3228 11.8103C20.9693 11.8103 20.6914 12.1019 20.5989 12.443C20.321 13.4677 19.3844 14.2213 18.2718 14.2213C17.1592 14.2213 16.2226 13.4677 15.9447 12.443C15.8521 12.1019 15.5743 11.8103 15.2208 11.8103H5.77227C4.00497 11.8103 2.57227 13.243 2.57227 15.0103V22.9084C2.57227 24.6757 4.00497 26.1084 5.77227 26.1084L15.2208 26.1084C15.5743 26.1084 15.8522 25.8168 15.9447 25.4757C16.2226 24.4511 17.1592 23.6974 18.2718 23.6974C19.3844 23.6974 20.321 24.4511 20.5989 25.4757C20.6915 25.8168 20.9694 26.1084 21.3228 26.1084H22.6847C24.452 26.1084 25.8847 24.6757 25.8847 22.9084V15.0103C25.8847 13.243 24.452 11.8103 22.6847 11.8103H21.3228Z",
    fill: "url(#paint4_radial_2149_30967)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0313 12.5603C20.7017 13.7752 19.5918 14.6693 18.2718 14.6693C16.9518 14.6693 15.8418 13.7752 15.5123 12.5603C15.4535 12.3435 15.3069 12.2583 15.2208 12.2583H5.77227C4.25239 12.2583 3.02027 13.4904 3.02027 15.0103V22.9084C3.02027 24.4283 4.25239 25.6604 5.77227 25.6604L15.2208 25.6604C15.3069 25.6604 15.4535 25.5753 15.5123 25.3584C15.8419 24.1436 16.9518 23.2494 18.2718 23.2494C19.5918 23.2494 20.7018 24.1436 21.0313 25.3584C21.0901 25.5753 21.2367 25.6604 21.3228 25.6604H22.6847C24.2046 25.6604 25.4367 24.4283 25.4367 22.9084V15.0103C25.4367 13.4904 24.2046 12.2583 22.6847 12.2583H21.3228C21.2367 12.2583 21.0901 12.3435 21.0313 12.5603ZM20.5989 12.443C20.6914 12.1019 20.9693 11.8103 21.3228 11.8103H22.6847C24.452 11.8103 25.8847 13.243 25.8847 15.0103V22.9084C25.8847 24.6757 24.452 26.1084 22.6847 26.1084H21.3228C20.9694 26.1084 20.6915 25.8168 20.5989 25.4757C20.321 24.4511 19.3844 23.6974 18.2718 23.6974C17.1592 23.6974 16.2226 24.4511 15.9447 25.4757C15.8522 25.8168 15.5743 26.1084 15.2208 26.1084L5.77227 26.1084C4.00497 26.1084 2.57227 24.6757 2.57227 22.9084V15.0103C2.57227 13.243 4.00497 11.8103 5.77227 11.8103H15.2208C15.5742 11.8103 15.8521 12.1019 15.9447 12.443C16.2226 13.4677 17.1592 14.2213 18.2718 14.2213C19.3844 14.2213 20.321 13.4677 20.5989 12.443Z",
    fill: "url(#paint5_radial_2149_30967)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_2149_30967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8841 20.19V15.0105C25.8841 13.2433 24.4514 11.8105 22.6841 11.8105H21.3221C20.9687 11.8105 20.6908 12.1022 20.5982 12.4433C20.3203 13.4679 19.3838 14.2216 18.2711 14.2216C17.1585 14.2216 16.222 13.4679 15.944 12.4433C15.8515 12.1022 15.5736 11.8105 15.2201 11.8105H6.12305V16.99C6.12305 18.7573 7.55572 20.19 9.32305 20.19H19.4114C19.4114 18.8584 20.4909 17.779 21.8224 17.779C23.154 17.779 24.2334 18.8584 24.2334 20.19H25.8841Z",
    fill: "url(#paint6_radial_2149_30967)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6,
    filter: "url(#filter3_f_2149_30967)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79219 14.0942C9.01587 13.3267 11.7398 9.49396 14.5152 10.1546C17.2907 10.8152 20.6792 14.5255 20.4555 15.2931C20.2318 16.0607 18.7239 18.5707 15.6445 18.5767C12.5651 18.5828 8.56851 14.8618 8.79219 14.0942Z",
    fill: "#A4E9FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_2149_30967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3451 18.1198C18.9304 18.1198 19.4049 17.6453 19.4049 17.06C19.4049 16.4746 18.9304 16.0001 18.3451 16.0001C17.7597 16.0001 17.2852 16.4746 17.2852 17.06C17.2852 17.6453 17.7597 18.1198 18.3451 18.1198ZM18.3451 22.1198C18.9304 22.1198 19.405 21.6452 19.405 21.0599C19.405 20.4745 18.9304 20 18.3451 20C17.7597 20 17.2852 20.4745 17.2852 21.0599C17.2852 21.6452 17.7597 22.1198 18.3451 22.1198Z",
    fill: "url(#paint7_linear_2149_30967)",
    fillOpacity: 0.7
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_di_2149_30967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16305 16C6.58865 16 6.12305 16.4656 6.12305 17.04C6.12305 17.6144 6.58865 18.08 7.16305 18.08H13.3087C13.883 18.08 14.3487 17.6144 14.3487 17.04C14.3487 16.4656 13.883 16 13.3087 16H7.16305ZM7.16305 20.0397C6.58865 20.0397 6.12305 20.5053 6.12305 21.0797C6.12305 21.6541 6.58865 22.1197 7.16305 22.1197H10.8324C11.4067 22.1197 11.8724 21.6541 11.8724 21.0797C11.8724 20.5053 11.4067 20.0397 10.8324 20.0397H7.16305Z",
    fill: "url(#paint8_linear_2149_30967)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2149_30967",
    x: 6.12305,
    y: 5.8913,
    width: 23.3125,
    height: 14.9381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.64
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2149_30967"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_2149_30967",
    x: 20.2936,
    y: 10.2637,
    width: 3.20383,
    height: 6.83322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.64
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.54902 0 0 0 0 0.858824 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2149_30967"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2149_30967",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect2_innerShadow_2149_30967"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2149_30967",
    x: 4.20305,
    y: 9.89055,
    width: 23.6017,
    height: 12.2194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.96,
    result: "effect1_foregroundBlur_2149_30967"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2149_30967",
    x: 3.0232,
    y: 4.31843,
    width: 23.2036,
    height: 20.0183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.88,
    result: "effect1_foregroundBlur_2149_30967"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_2149_30967",
    x: 16.6452,
    y: 16.0001,
    width: 3.39914,
    height: 7.39969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.64
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.54902 0 0 0 0 0.858824 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2149_30967"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2149_30967",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect2_innerShadow_2149_30967"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_2149_30967",
    x: 5.48305,
    y: 16,
    width: 9.50656,
    height: 7.39969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.64
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.54902 0 0 0 0 0.858824 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2149_30967"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2149_30967",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect2_innerShadow_2149_30967"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2149_30967",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.897273 17.547) rotate(-10.467) scale(34.785 21.6401)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#44BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#0032AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2149_30967",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4355 27.0013) rotate(-136.932) scale(31.9111 40.5078)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#44BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#0032AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2149_30967",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4.00879 9.76125) rotate(10.987) scale(28.1256 10.9508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#44BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#002FA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2149_30967",
    x1: 21.493,
    y1: 8.39484,
    x2: 22.1632,
    y2: 9.48831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DDF7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2149_30967",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.2942 21.32) rotate(-11.8767) scale(27.0994 38.8662)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#32C1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#237CD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2149_30967",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8275 11.8094) rotate(116.993) scale(19.0772 13.1572)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#DEFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2149_30967",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-11.0505 6.24863) rotate(8.867) scale(38.9686 23.6743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#44BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#0032AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2149_30967",
    x1: 17.9016,
    y1: 13.9406,
    x2: 18.6402,
    y2: 15.1456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DDF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2149_30967",
    x1: 7.94122,
    y1: 19.6515,
    x2: 7.94295,
    y2: 19.7989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DDF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.a2abe251d5dde0e457d46b0c434cec2a.svg";
export { ForwardRef as ReactComponent };